import { createSlice } from "@reduxjs/toolkit";

export const categoriesSlice = createSlice({
  name: "categories",
  initialState: {
    data: [],
    currentCategory: null,
    selectedModal: null,
  },
  reducers: {
    addCategory: (state, action) => {
      state.data.push(action.payload);
    },
    setData: (state, action) => {
      state.data = action.payload;
      state.init = true;
    },
    setSelectedModal: (state, action) => {
      state.selectedModal = action.payload;
    },
    setCurrentCategory: (state, action) => {
      state.currentCategory = action.payload;
    },
    updateCategory: (state, action) => {
      const { id } = action.payload;
      const index = state.data.findIndex((item) => item.id === id);
      if (index !== -1) {
        state.data[index] = action.payload;
      }
    },
    deleteCategory: (state, action) => {
      const { id } = action.payload;
      state.data = state.data.filter((item) => item.id !== id);
    },
  },
});

export const {
  addCategory,
  setData,
  setSelectedModal,
  setCurrentCategory,
  updateCategory,
  deleteCategory,
} = categoriesSlice.actions;

export default categoriesSlice.reducer;
